import type { IEntityModel } from './base'
import type { IDexcomIntegration } from './dexcom_integration'
import type { IIdentity } from './identity'
import type { IPurchase } from './purchase'

export enum WorkspaceType {
  Global = 'global',
  User = 'user',
}

export interface IWorkspace extends IEntityModel {
  name: string
  type: WorkspaceType
  identityId: string
  identity?: IIdentity
  participantLimit: number
  dexcomIntegrationList?: IDexcomIntegration[]
  totalParticipants: number
  purchaseList?: IPurchase[]
}
